import React, { useState } from 'react';
import { Sparkles } from 'lucide-react';
import { AIResponse } from './AIResponse';

export const FluencyAIBar = ({ onAskAI, aiResponse, isLoading }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [query, setQuery] = useState('');
  const [showResponse, setShowResponse] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim()) {
      onAskAI(query);
      setQuery('');
      setIsExpanded(false);
      setShowResponse(true);
    }
  };

  const handleClick = () => {
    if (!isExpanded) {
      setIsExpanded(true);
    }
  };

  const handleBlur = (e) => {
    if (!e.currentTarget.contains(e.relatedTarget)) {
      if (!query.trim()) {
        setIsExpanded(false);
      }
    }
  };

  const handleCloseResponse = () => {
    setShowResponse(false);
  };

  return (
    <div className="relative mt-4">
      {/* Show AI Response if available */}
      {showResponse && (
        <AIResponse 
          content={aiResponse} 
          isLoading={isLoading} 
          onClose={handleCloseResponse}
          onAskAI={onAskAI}
        />
      )}
      
      {/* Input Bar */}
      <div className="relative pt-4">
        {!isExpanded ? (
          <button
            onClick={handleClick}
            className="w-full flex items-center gap-3 px-3 py-2 bg-white rounded-lg border border-gray-400 hover:bg-gray-100 transition-colors"
          >
            <Sparkles className="text-gray-400" size={20} />
            <span className="text-teal-600">Ask Preface Intelligence</span>
          </button>
        ) : (
          <form onSubmit={handleSubmit} onBlur={handleBlur} className="flex items-center gap-3">
            <div className="flex items-center flex-1 px-3 py-2 bg-white rounded-lg border border-gray-400">
              <Sparkles className="text-gray-400 mr-2" size={20} />
              <input
                type="text"
                placeholder="Eg. Write a work note"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                className="flex-1 bg-transparent text-gray-700 placeholder-gray-400 focus:outline-none"
                autoFocus
              />
            </div>
          </form>
        )}
      </div>
    </div>
  );
};